import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import styles from "../layout/css/settingLayout.module.css";

const Modal = ({
  show = false,
  isOpen = false,
  onClose,
  title = "Modal Dialog",
  children,
  body,
}) => {
  const isVisible = show || isOpen;
  const content = children || body;

  if (!isVisible) return null;

  return (
    <AnimatePresence>
      <div className={styles.modalBackdrop} onClick={onClose}>
        <motion.div
          className={styles.modalCard}
          initial={{ opacity: 0, scale: 0.95, y: 10 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: 10 }}
          transition={{ type: "spring", stiffness: 300, damping: 25 }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className={styles.modalHeader}>
            <h5 className={styles.modalTitle}>{title}</h5>
            <button type="button" className={styles.btnClose} onClick={onClose}>
              <i className="fas fa-times"></i>
            </button>
          </div>
          <div className={styles.modalBody}>{content}</div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default Modal;
